import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
         {
          path: '/',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '北京洞察力科技股份有限公司'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '业务解决方案'
          },
          children: [
            // {
            //   path: '/software',
            //   redirect: '/software/smartTown'
            // },
            // {
            //   path: '/software/smartTown',
            //   name: 'software',
            //   component: resolve => require(['@/view/Software_smartTown'], resolve),
            //   meta: {
            //     title: '软件产品丨智能小镇管理系统'
            //   }
            // },
            // {
            //   path: '/software/bigData',
            //   name: 'software',
            //   component: resolve => require(['@/view/Software_bigData'], resolve),
            //   meta: {
            //     title: '软件产品丨大数据管理系统'
            //   }
            // }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '技术解决方案'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '企业和社会责任'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '员工成长计划'
          }
        },

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js